import { useEffect } from 'react';

import { useOnboardingSteps, useRulesEngine } from '@/modules/rulesEngine';
import { LoadingScreen } from '@/modules/ui';

import { EligibilityFieldsForm } from './components/EligibilityFieldsForm';
import { InviteCodeForm } from './components/InviteCodeForm';

export function EmployerOrHealthPlanVerificationScreen() {
  const { selectedOrg } = useRulesEngine();
  const { goToNextStep } = useOnboardingSteps();

  useEffect(() => {
    if (!selectedOrg) {
      goToNextStep();
    }
  }, [selectedOrg, goToNextStep]);

  if (!selectedOrg) {
    return <LoadingScreen />;
  }

  if (selectedOrg.supportsEligibilityCheck) {
    return <EligibilityFieldsForm />;
  }

  return <InviteCodeForm />;
}
